import React from 'react';

type Direction = 'horizontal' | 'vertical' | 'diagonal-right' | 'diagonal-left';

interface GameCellProps {
  value: string;
  row: number;
  col: number;
  disabled: boolean;

  onCellClick: (row: number, col: number) => void;
  directions: Direction[];
}

const lineClasses: Record<Direction, string> = {
  horizontal: 'h-0.5 sm:h-1 w-full top-1/2 -translate-y-1/2',
  vertical: 'w-0.5 sm:w-1 h-full left-1/2 -translate-x-1/2',
  'diagonal-right': 'w-[142%] h-0.5 sm:h-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-45',
  'diagonal-left': 'w-[142%] h-0.5 sm:h-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45',
};

const GameCell: React.FC<GameCellProps> = ({ value, disabled, onCellClick, row, col, directions }) => {
  return (
    <button
      onClick={() => onCellClick(row, col)}
      disabled={disabled || !!value}
      className="relative flex items-center justify-center w-8 h-8 sm:w-12 sm:h-12 bg-white rounded-sm shadow-sm transition-colors duration-200 hover:bg-gray-100 disabled:bg-gray-50 disabled:cursor-not-allowed"
    >
      <span className={`font-bold text-lg sm:text-2xl ${value === 'S' ? 'text-blue-600' : 'text-red-500'}`}>
        {value}
      </span>
      {directions.map((dir) => (
        <div
          key={dir}
          className={`absolute bg-red-500 rounded-full z-10 ${lineClasses[dir]}`}
        ></div>
      ))}

    </button>
  );
};

export default GameCell;